import i18n from '@/plugins/i18n';
import VueLocalizedFormatter from './formatter';

export default new VueLocalizedFormatter({ locale: i18n.locale, i18n });
